import {
  Typography, Upload, Form, Button, Input, Row, Col, Space, Image
} from "antd";

import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import useProfile from "./useProfile";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { PhoneNumberInput } from "../../Form";

const { Text } = Typography;

const Profile = () => {
  const { t } = useTranslation();
  const {
    form,
    loading,
    onFileChange,
    onSubmit,
    beforeUpload,
    handlePreview,
    setPreviewOpen,
    previewOpen,
    setPreviewImage,
    fileList,
    previewImage
  } = useProfile();

  const { isDoctor } = useCurrentUser();

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{t("settingsPage.profile.uploadButton")}</div>
    </button>
  );

  return (
    <>
      <Row gutter={[8, 8]} style={{ marginBottom: 8 }} align="middle">
        <Col flex="auto">
          <Space direction="vertical">
            <Text strong style={{ fontSize: 22, lineHeight: 1 }}>{t("settingsPage.profile.title")}</Text>
            <Text type="secondary" style={{ fontSize: 18, lineHeight: 1 }}>
              {t("settingsPage.profile.subtitle")}
            </Text>
          </Space>
        </Col>
        <Col>
          <Space style={{ width: "100%", justifyContent: "flex-end" }}>
            <Button onClick={() => form.resetFields()}>{t("global.button.cancel")}</Button>
            <Button type="primary" disabled={loading} loading={loading} onClick={() => form.submit()}>{t("global.button.save")}</Button>
          </Space>
        </Col>
      </Row>
      <Row gutter={24}>
        {isDoctor
          && (
          <Col span={24} md={12}>
            <Form
              form={form}
              layout="vertical"
              requiredMark="optional"
            >
              <Form.Item name="photo">
                <Upload
                  action="https://httpbin.org/post"
                  listType="picture-card"
                  fileList={fileList}
                  onChange={onFileChange}
                  beforeUpload={beforeUpload}
                  onPreview={handlePreview}
                >
                  {fileList.length >= 2 ? null : uploadButton}
                </Upload>
              </Form.Item>
              {previewImage ? (
                <Image
                  wrapperStyle={{ display: "none" }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) => !visible && setPreviewImage(""),
                  }}
                  src={previewImage}
                />
              ) : null}
              <Form.Item name="bio" label="Bio" tooltip="test">
                <Input.TextArea rows={6} />
              </Form.Item>
            </Form>
          </Col>
          )}
        <Col span={24} md={12}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            requiredMark="optional"
          >
            <Form.Item
              name="name"
              label={t("form.label.name")}
              rules={[{ required: true, message: t("form.error.name") }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="surname"
              label={t("form.label.surname")}
              rules={[{ required: true, message: t("form.error.surname") }]}
            >
              <Input />
            </Form.Item>
            {isDoctor ? (
              <Form.Item
                name="studies"
                label={t("form.label.study")}
                rules={[{ required: true, message: t("form.error.study") }]}
              >
                <Input />
              </Form.Item>
            ) : null}

            <PhoneNumberInput
              name="phone"
              label={t("form.label.phone")}
            />

            {!isDoctor ? (
              <Form.Item
                name="bio"
                label={t("form.label.bio")}
                tooltip="test"
                style={{ marginBottom: 0 }}
              >
                <Input.TextArea rows={3} />
              </Form.Item>
            ) : null}
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default Profile;
